import { styled } from "goober";
import { Icon } from "./Icon";
import { Text } from "./Text";

export const Fields = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Row = styled("div")`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
`;

const Field = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const FieldLabel = styled("div")`
  padding: 0 8px;
`;

const FieldValue = styled("div")`
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 8px 12px;
  box-sizing: border-box;
  background: var(--alpha4);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 8px;
  min-width: 0;
  color: var(--text-primary);
  font-family: InterVariable;
  font-size: 12px;
  line-height: 16px;

  & > * {
    min-width: 0;
  }
`;

const Value = styled("span")`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const FieldLink = styled("a")`
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 32px;
  padding: 8px 12px;
  box-sizing: border-box;
  background: var(--alpha4);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 8px;
  min-width: 0;
  color: var(--text-primary);
  font-family: InterVariable;
  font-size: 12px;
  line-height: 16px;
  text-decoration: none;

  &:hover {
    background: var(--alpha8);
  }

  & > *:first-child {
    flex: 1;
    min-width: 0;
  }
`;

export function LinkField({
  label,
  value,
  href,
}: {
  label: string;
  value: string;
  href: string;
}) {
  return (
    <Field>
      <FieldLabel>
        <Text variant="text-small-md" color="var(--text-primary)">
          {label}
        </Text>
      </FieldLabel>
      <FieldLink
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        title={value}
      >
        <Value>{value}</Value>
        <span style={{ display: "flex", flexShrink: 0 }}>
          <Icon name="arrow-up-right" size={12} color="var(--text-secondary)" />
        </span>
      </FieldLink>
    </Field>
  );
}

export function ValueField({
  label,
  value,
  title,
}: {
  label: string;
  value: string;
  title?: string;
}) {
  return (
    <Field>
      <FieldLabel>
        <Text variant="text-small-md" color="var(--text-primary)">
          {label}
        </Text>
      </FieldLabel>
      <FieldValue>
        <Value title={title}>{value}</Value>
      </FieldValue>
    </Field>
  );
}
